import Box from "@/components/Box";
import { LEVELS } from "@/components/studentApplication/Levels";
import { PanelBoxV2 } from "@/tpo/Boxes";
import { useTheme } from "styled-components";

export default function StudentPractitionerUpgradePending({ level }) {
  const theme = useTheme();
  const levelInfo = LEVELS[level];

  return (
    <PanelBoxV2
      maxWidth={640}
      outer={{
        pt: theme.spacing.section.pt,
        pb: theme.spacing.section.pb,
        px: [20],
        bg: "white"
      }}
      gap={28}
      stacked
    >
      <Box fontFamily="gilroyBold" fontSize={[36]} lineHeight={["46px"]}>
        {levelInfo ? `${levelInfo.label} application submitted` : "Application submitted"}
      </Box>
      <Box fontFamily="gilroyMedium" fontSize={[16]} lineHeight={["24px"]}>
        {levelInfo
          ? `Thanks for applying to become a ${levelInfo.fullName.toLowerCase()}. `
          : "Thanks for applying. "}
        We will let you know as soon as you have been approved. If you have any questions please
        contact info@regeneruslabs.com
      </Box>
    </PanelBoxV2>
  );
}
